import { render } from "./ParcRdv.vue?vue&type=template&id=2653b413&scoped=true"
import script from "./ParcRdv.vue?vue&type=script&lang=js"
export * from "./ParcRdv.vue?vue&type=script&lang=js"

import "./ParcRdv.vue?vue&type=style&index=0&id=2653b413&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2653b413"]])

export default __exports__